import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Subcontractors, SubcontractorsDropdown } from '../../models';
import { HttpClient } from '@angular/common/http';
import { CreateSubcontractorRequest, PaginationSubcontractorRequest, SubcontractorEmailUpdateModel } from '../subcontractor';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { requestQuery } from '../../../@shared/untils';

@Injectable()
export class SubcontractorService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
    ) { }
    public getSubcontractors(request: PaginationSubcontractorRequest, disableSpinner?: boolean): Observable<PaginationResponse<Subcontractors>> {
        if (!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.get<PaginationResponse<Subcontractors>>(`${API.SUBCONTRACTOR.GET_SUBCONTRACTORS}?${requestQuery(request)}`)
            .pipe(tap(() => this._spinner.hide()));
    }

  public getAllSubcontractorsDropdown(search: string): Observable<SubcontractorsDropdown[]> {

    return this._http.get<SubcontractorsDropdown[]>(`${API.SUBCONTRACTOR.GET_ALL_SUBCONTRACTORS_FOR_DROPDOWN(search)}`);

  }
  

    public create(model: CreateSubcontractorRequest) {
        return this._http.post(`${API.SUBCONTRACTOR.CREATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_SUBCONTRACTOR);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }

    public update(model: CreateSubcontractorRequest, id: string) {
        return this._http.put(API.SUBCONTRACTOR.UPDATE(id), model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_SUBCONTRACTOR);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    public delete(id: string) {
        return this._http.delete(API.SUBCONTRACTOR.DELETE(id))
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.DELETE_SUBCONTRACTOR);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }

    public verifyEmail(subcontractorId: string): Observable<any> {
        return this._http.get(API.SUBCONTRACTOR.VERIFY_EMAIL(subcontractorId)).pipe(tap(() => this._spinner.hide()));
    }

    public updateEmail(model: SubcontractorEmailUpdateModel): Observable<any> {
        return this._http.patch(API.SUBCONTRACTOR.UPDATE_EMAIL, model).pipe(tap(() => this._spinner.hide()));
    }

    public sendEmail(subcontractorEmailModel): Observable<any> {
        return this._http.post(API.SUBCONTRACTOR.SEND_EMAIL, subcontractorEmailModel).pipe(tap(() => this._spinner.hide()));
    }

    // CRATE CreateXeroContact
    public CreateXeroContact(model) {
        return this._http.post(`${API.SUBCONTRACTOR.CREATEXEROCONTACT}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_SUBCONTRACTOR_XERO);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }

  public getSubcontractorsForDropdown(searchText: string): Observable<Subcontractors[]> {
    return this._http.get<Subcontractors[]>(`${API.SUBCONTRACTOR.GET_SUBCONTRACTORS_FOR_DROPDOWN(searchText)}`);
            
  }

  public getHxSubcontractorsForDropdown(searchText: string): Observable<Subcontractors[]> {
    return this._http.get<Subcontractors[]>(`${API.SUBCONTRACTOR.GET_HXSUBCONTRACTORS_FOR_DROPDOWN(searchText)}`);

  }

}
